// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { qtyFieldStyles } from "@guestsupply/App/Components/Qty/QtyField";
import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { savedOrderDetailsCartLineStyles } from "@guestsupply/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

savedOrderDetailsCartLineStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

savedOrderDetailsCartLineStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

savedOrderDetailsCartLineStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

savedOrderDetailsCartLineStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

savedOrderDetailsCartLineStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

savedOrderDetailsCartLineStyles.cartLineErrorMessageText = {
    ...cartLineSharedStyles.errorMessage,
};

savedOrderDetailsCartLineStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};
savedOrderDetailsCartLineStyles.cartLineQuantity = {
    readOnlyQuantityText: {
        extendedStyles: {
            heading: {
                ...mergeWithCss(qtyFieldStyles.qtyLabel, {
                    as: "label",
                    size: 12,
                    weight: "normal",
                    lineHeight: "13px",
                    css: css`
                        margin-bottom: 4px;
                        display: none;
                        text-transform: capitalize;
                        ${xScreen("lte", "md")} {
                            display: block;
                            padding-bottom: 7px;
                        }
                    `,
                }),
            },
            text: {
                ...mergeWithCss(qtyFieldStyles.qtyLabel, {
                    size: 16,
                    weight: "bold",
                    lineHeight: "17px",
                    css: css`
                        text-align: start;
                        display: flex;
                        line-height: 17px;
                    `,
                }),
            },
        },
    },
};

savedOrderDetailsCartLineStyles.smallHeadingStyle = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                height: 18px;
                margin-bottom: 4px;
                margin-right: 8px;
                width: auto;
                @media print {
                    display: flex;
                }
            `,
        },
    }),
};

savedOrderDetailsCartLineStyles.productImageBadgesStyle = {
    container: {
        css: css`
            @media print {
                margin-bottom: 8px;
            }
        `,
    },
};

